import { createRoot } from 'react-dom/client'
import AppRoutes from "./routes";

createRoot(document.getElementById('react-container')).render(<AppRoutes />);
